
import { useModal } from '../../../hooks/useModal'
import ImportModal from '../../@Common/Modal/ImportModal'
import { useLazyGetNetSuiteImportQuery, useLazyGetNetSuiteImportsQuery, useAddNetSuiteImportMutation } from '../../../redux/slices/partnersSlice'

const getImportTypeText = (importType) => {
    switch (importType) {
        case 1:
            return 'Shopify Payouts'
        default:
            return ''
    }
}

const useNetSuiteImports = ({ importType }) => {
    const importTypeText = getImportTypeText(importType)
    const modalKey = `IMPORT_${importTypeText.toUpperCase().replaceAll(' ', '_')}`

    const {
        openModal, closeModal,
    } = useModal({
        [modalKey]: {
            component: ImportModal,
        },
    })

    const [addNetSuiteImportAsync] = useAddNetSuiteImportMutation()
    const [getNetSuiteImportAsync] = useLazyGetNetSuiteImportQuery()
    const [getNetSuiteImportsAsync] = useLazyGetNetSuiteImportsQuery()

    const addImportAsync = async (importFile) => {
        const res = await addNetSuiteImportAsync({ importFile, importType })
        return res
    }

    const getImportAsync = async (id) => {
        const res = await getNetSuiteImportAsync({ id })
        return res.data
    }
    const getImportsAsync = async () => {
        const res = await getNetSuiteImportsAsync({ importType })
        const unsorted = res.data ? [...res.data] : []
        const sorted = unsorted.sort((a, b) => new Date(b.processedOnUtc) - new Date(a.processedOnUtc))
        return sorted
    }

    return {
        addImportAsync,
        getImportAsync,
        getImportsAsync,
        importTypeText,
        openModal,
        closeModal,
        modalKey,
    }
}

export default useNetSuiteImports
